import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getQueryParameter } from '../../../../utilities';
import { ViewFaqPage, EditFaqPage, CreateFaqPage } from '../index';
import { INavigableComponent } from '../../../../interfaces';
import { ToolbarContextEnum } from '../../../../enums';
import { securityService } from '../../../../_global/services';
import { UserPermissions } from '../../../../definitions';

interface ItemPageProps {
  config: any;
  data: any;
}

export default function ItemPage({
  config,
  data,
  setBreadcrumbs,
  setToolbarConfig
}: ItemPageProps & INavigableComponent) {
  const location = useLocation();
  const mode = getQueryParameter(location.search, 'mode');
  useEffect(() => {
    let context;

    switch (mode) {
      case 'add':
        context = ToolbarContextEnum.CreateItem;
        break;
      case 'edit':
        context = ToolbarContextEnum.EditItem;
        break;
      default:
        context = ToolbarContextEnum.ViewItem;
        break;
    }

    setToolbarConfig?.({ ...config, context, item: data });
  }, [mode]);

  if (!securityService.checkRoleAccess(UserPermissions.viewFaqs))
    return (
      <>
        <h2 className={'text-center'}>No view permissions.</h2>
      </>
    );

  switch (mode) {
    case 'add':
      return <CreateFaqPage data={data} />;
    case 'edit':
      return <EditFaqPage data={data} />;
    default:
      return <ViewFaqPage data={data} />;
  }
}
